import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/wallet-engine/page.tsx");
